<template>
  <div>
    <el-form :model="value" ref="formRef" :rules="formRules" label-width="95px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="车场名称:" prop="spaceId">
            <el-select v-model="value.spaceId" style="width: 100%" placeholder="请选择" disabled>
              <el-option
                v-for="item in spaceList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车牌号:" prop="carNo">
            <el-input
              clearable
              disabled
              v-model="value.carNo"
              placeholder="请输入车牌号"
              @blur="carNoBlur"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="区域名称:" prop="regions">
            <avue-input-tree
              style="width: 100%"
              :props="treeRegionProps"
              v-model="value.regions"
              placeholder="请选择区域"
              type="tree"
              multiple
              checkStrictly
              :dic="regionList"
            ></avue-input-tree>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆类别:" prop="driverType">
            <el-select
              v-model="value.driverType"
              style="width: 100%"
              placeholder="请选择车辆类别"
              @change="driverTypeChange"
            >
              <el-option
                v-for="item in carCategoryList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车辆类型:" prop="carType">
            <el-select
              v-model="value.carType"
              style="width: 100%"
              placeholder="请选择车辆类型"
              @change="carTypeChange"
            >
              <el-option
                v-for="item in carTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="收费套餐:" prop="ruleId">
            <el-select v-model="value.ruleId" style="width: 100%" placeholder="请选择收费套餐">
              <el-option
                v-for="item in ruleList"
                :key="item.id"
                :label="item.setmealName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁起期:" prop="buyStartTime">
            <el-date-picker
              v-model="value.buyStartTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 00:00:00"
              align="right"
              type="date"
              placeholder="选择租赁起期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="租赁止期:" prop="buyEndTime">
            <el-date-picker
              v-model="value.buyEndTime"
              style="width: 100%"
              value-format="yyyy-MM-dd 23:59:59"
              align="right"
              type="date"
              placeholder="选择租赁止期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="优惠规则:" prop="discountId">
            <el-select v-model="value.discountId" style="width: 100%" placeholder="请选择优惠规则">
              <el-option
                v-for="item in discountRuleList"
                :key="item.id"
                :label="item.discountName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户姓名:" prop="customerName">
            <el-input
              clearable
              disabled
              v-model="value.customerName"
              placeholder="请输入客户姓名"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户手机:" prop="customerPhone">
            <el-input
              clearable
              disabled
              v-model="value.customerPhone"
              placeholder="请输入客户手机"
              maxlength="20"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="房产信息:" prop="areaName">
            <el-input clearable disabled v-model="value.areaName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="车位编号:" prop="lotNo">
            <el-input clearable disabled v-model="value.lotNo" maxlength="20"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="月卡车状态:" prop="status">
            <el-select v-model="value.status" style="width: 100%" placeholder="请选择月卡车状态">
              <el-option
                v-for="item in statusList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注:" prop="remark1">
            <el-input
              clearable
              v-model="value.remark1"
              type="textarea"
              :rows="4"
              placeholder="请输入备注"
              show-word-limit
              maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="float: right">
            <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="saveRecord"
              size="small"
              >修改
            </el-button>
            <el-button icon="el-icon-circle-close" @click="cancelRecord" size="small">
              取消
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { nodeTreeByParentId } from '@/api/v4ward/carv2/carmonth';
import { editPlusCarMonth } from '@/api/v4ward/carv2/carcharge';
import { getSpaceList, isCarMonth } from '@/api/v4ward/carv2/carmonthquickRegistration';
import { getDictionary } from '@/api/common.js';
import {
  monthChargeRuleListV2,
  editPlusGetDiscountId,
} from '@/api/v4ward/carv2/carmonthchargerule';
export default {
  props: ['value'],
  data() {
    return {
      regionList: [],
      treeRegionProps: {
        labelText: '标题',
        label: 'title',
        value: 'id',
        children: 'children',
      },
      carTypeList: [], //车辆类型
      carCategoryList: [], //车辆类别
      ruleList: [], //收费套餐
      discountRuleList: [], //优惠规则
      statusList: [], //月卡车状态
      spaceList: [], //车场
      formRules: {
        spaceId: [{ required: true, message: '车场名称不能为空', trigger: 'blur' }],
        carNo: [{ required: true, message: '车牌号不能为空', trigger: 'blur' }],
        regions: [{ required: true, message: '区域不能为空', trigger: 'blur' }],
        driverType: [{ required: true, message: '车辆类别不能为空', trigger: 'blur' }],
        carType: [{ required: true, message: '车辆类型不能为空', trigger: 'blur' }],
        ruleId: [{ required: true, message: '收费套餐不能为空', trigger: 'blur' }],
        buyStartTime: [{ required: true, message: '租赁起期不能为空', trigger: 'blur' }],
        buyEndTime: [{ required: true, message: '租赁止期不能为空', trigger: 'blur' }],
        customerName: [{ required: true, message: '客户姓名不能为空', trigger: 'blur' }],
        status: [{ required: true, message: '月卡车状态不能为空', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.value.carType += '';
    this.value.driverType += '';
    this.value.ruleId += '';
    this.value.status += '';
    this.initData();
  },
  methods: {
    driverTypeChange() {
      this.value.ruleId = '';
      this.value.discountId = '';
      if (this.value.carType && this.value.driverType) {
        this.getCarRule();
      }
    },
    carTypeChange() {
      this.value.ruleId = '';
      this.value.discountId = '';
      if (this.value.carType && this.value.driverType) {
        this.getCarRule();
      }
    },
    carNoBlur() {
      isCarMonth({
        spaceId: this.value.spaceId,
        carNo: this.value.carNo,
      });
    },
    initData() {
      this.getSpaceList();
      this.getRegion(this.value.spaceId);
      this.getCarCategory();
      this.getCarType();
      this.getDiscountList();
      this.getCarMonthStatus();
      this.getCarRule();
    },
    getSpaceList() {
      getSpaceList().then((res) => {
        this.spaceList = res.data;
      });
    },
    //获取区域
    getRegion(id) {
      nodeTreeByParentId(id).then((res) => {
        this.regionList = res.data;
      });
    },
    //获取车辆类别(车主类别)
    getCarCategory() {
      getDictionary('car_category_v2').then((res) => {
        this.carCategoryList = res.data;
      });
    },
    //车辆类型
    getCarType() {
      getDictionary('car_type_v2').then((res) => {
        this.carTypeList = res.data;
      });
    },
    //获取收费套餐
    getCarRule() {
      monthChargeRuleListV2(
        Object.assign({
          spaceId: this.value.spaceId,
          carType: this.value.carType,
          carCategory: this.value.driverType,
        })
      ).then(({ data }) => {
        this.ruleList = data;
      });
    },
    //获取优惠规则
    getDiscountList() {
      editPlusGetDiscountId({
        spaceId: this.value.spaceId,
        chargeRuleId: this.value.ruleId,
      }).then((res) => {
        this.discountRuleList = res.data;
      });
    },
    getCarMonthStatus() {
      getDictionary('car_month_status').then((res) => {
        this.statusList = res.data;
      });
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          this.value.carCategory = this.value.driverType;
          editPlusCarMonth(this.value).then((res) => {
            this.$message.success('修改成功');
            this.$emit('success');
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancelRecord() {
      console.log('触发关闭');
      this.$confirm('是否关闭继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$emit('cancel');
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
  },
};
</script>
<style scoped>
::v-deep .el-col-8 {
  height: 54px;
}
</style>
